import { compose, get, isEqual, first, values, toLower, pickBy } from 'lodash/fp';
import { flow } from 'fp-ts/function';
import { createSelector } from 'reselect';
import { createAsyncActionTypes, createScopedReducer } from '@mews/framework';
import { getOrEmptyObject, gtZero, getOrFalse, getStringProp, getProp } from '@mews/fp';
import { PaymentCardType } from '@mews/enums';
import { notNil, createEntitySelector } from '@mews-commander/utils';
import moduleSelector from '../selector';
import prefix from '../prefix';
import { META_STATE_SUCCEEDED, META_STATE_STARTED, META_STATE_FAILED } from '../constants';

export const NAME = 'accountingConfigurations';

export const ACCOUNTING_CONFIGURATION_FETCH = prefix('ACCOUNTING_CONFIGURATION_FETCH');
export const [
    ACCOUNTING_CONFIGURATION_FETCH_STARTED,
    ACCOUNTING_CONFIGURATION_FETCH_SUCCEEDED,
    ACCOUNTING_CONFIGURATION_FETCH_FAILED,
] = createAsyncActionTypes(ACCOUNTING_CONFIGURATION_FETCH);

export const accountingConfigurationsReducer = createScopedReducer(
    { ...META_STATE_SUCCEEDED },
    {
        // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
        [ACCOUNTING_CONFIGURATION_FETCH_SUCCEEDED]: (state, payload) => ({
            configuration: payload,
            ...META_STATE_SUCCEEDED,
        }),
        [ACCOUNTING_CONFIGURATION_FETCH_STARTED]: () => ({
            ...META_STATE_STARTED,
        }),
        [ACCOUNTING_CONFIGURATION_FETCH_FAILED]: () => ({
            ...META_STATE_FAILED,
        }),
    }
);

const getAccountingConfigurations = compose(getOrEmptyObject(NAME), moduleSelector);
const getAccountingConfigurationState = createEntitySelector(
    getAccountingConfigurations,
    getStringProp('enterpriseId')
);
export const getAccountingConfigurationData = flow(getAccountingConfigurationState, get('configuration'));
const getAccountingConfigurationMeta = compose(get('meta'), getAccountingConfigurationState);

export const hasAccountingConfigurationFetchFailed = compose(get('hasFailed'), getAccountingConfigurationMeta);

export const getSurchargeServiceId = compose(get('surchargeServiceId'), getAccountingConfigurationData);

export const isSurchargingEnabled = compose(notNil, getSurchargeServiceId);

export const getSurchargeFees = compose(getOrEmptyObject('surchargeFees'), getAccountingConfigurationData);

export const getSurchargeFee = createSelector(
    getSurchargeFees,
    getProp<PaymentCardType>()('paymentCardType'),
    (fees, cardType) => {
        const pickedFees = pickBy((value, key) => isEqual(toLower(key), toLower(cardType)), fees);
        return first(values(pickedFees));
    }
);

export const hasSurchargeFee = compose(gtZero, getSurchargeFee);

export const getAccountingCategorySetupRequiredProp = getOrFalse('options.requireAccountingCategorySetup');

export const isAccountingCategorySetupRequired = createSelector(
    getAccountingConfigurationData,
    getAccountingCategorySetupRequiredProp
);
